import { identity, last, noop, times } from "lodash-es";
import { createEffect, createSignal, onCleanup } from "solid-js";

import {
	BROWSING_STATE,
	CARDS_STATE,
	REPERTOIRE_STATE,
	UI,
	USER_STATE,
	quick,
} from "~/utils/app_state";
import { AuthStatus } from "~/utils/user_state";

import { AskAboutUserSource } from "~/components/AskAboutUserSource";
import { BonusMoveView } from "~/components/BonusMoveView";
import { PreAdd } from "~/components/PreAdd";
import { PreReview } from "~/components/PreReview";
import { RepertoireBuilder } from "~/components/RepertoireBuilder";
import { RepertoireOverview } from "~/components/RepertoirtOverview";
import { OnboardingIntro } from "~/components/SidebarOnboarding";
import { Epd } from "~/types/Epd";
import { Line } from "~/types/Line";
import { START_EPD } from "./chess";
import { isDevelopment } from "./env";
import { SOUNDS, playSound } from "./sounds";
import { EVAL_NODES, onStockfishLoaded } from "./stockfish";

import { showerFeedbackConfetti, showerSuccessConfetti } from "~/components/Confetti";
import { RepertoireAudit } from "~/components/RepertoireAudit";
import { ChessboardViewState } from "./chessboard_interface";
import { sleep } from "./sleep";

// import { SidebarViewTester } from "~/components/SidebarViewTester";

export const createDebugStateEffect = () => {
	const dataLoading = () =>
		REPERTOIRE_STATE().repertoires == null && CARDS_STATE().cards === undefined;
	const authStatus = () => USER_STATE().authStatus;
	const [hasCalled, setHasCalled] = createSignal(false);
	createEffect(() => {
		if (hasCalled() || !isDevelopment) {
			return;
		}
		if (dataLoading() || authStatus() !== AuthStatus.Authenticated) {
			return;
		}

		setHasCalled(true);

		// for weird chessboard pieces disappearing bug, can modify the sleep time to test out. Works currently
		// (async () => {
		// 	// await sleep(1000);
		// 	console.log("pointer down");
		// 	quick((s) => {
		// 		UI().getActiveChessboard().playLine(["e4", "c5", "d4", "cxd4", "c3", "dxc3"], {
		// 			animated: true,
		// 		});
		// 	});
		// 	let chessboard = UI().getActiveChessboard().get();
		// 	chessboard.interactions.pointerDown("g1");
		// 	// chessboard.interactions.pointerUp("e2");
		// 	await sleep(100);
		// 	// console.log("pointer down again");
		// 	chessboard.interactions.pointerDown("f3");
		// })();

		// quick((s) => {
		// 	UI().pushView(RepertoireBuilder);
		// 	BROWSING_STATE().setActiveRepertoire(REPERTOIRE_STATE().getDefaultRepertoire("white")!.id);
		// 	s.repertoireState.browsingState.chessboard.playLine(
		// 		Line.fromPgn("1. e4 e5 2. Nf3 Nf6 3. Nxe5 Nc6 4. Nxc6 dxc6 "),
		// 		{
		// 			animated: true,
		// 			onFinished: () => {
		// 				console.log("finished playing line!");
		// 			},
		// 		},
		// 	);
		// });

		// line which has no moves
		// let f = () => {
		// 	quick((_s) => {
		// 		const setFeedback = (feedback: ChessboardViewState["moveFeedback"]) => {
		// 			quick((s) => {
		// 				s.repertoireState.browsingState.chessboard.showMoveFeedback(
		// 					{
		// 						square: "e4",
		// 						result: "correct",
		// 					},
		// 					() => {},
		// 				);
		// 			});
		// 		};
		// 		(async () => {
		// 			// setFeedback({ result: "thinking", progress: 0.5 });
		// 			// await sleep(1000);
		// 			setFeedback({ result: "correct" });
		// 			await sleep(3000);
		// 			REPERTOIRE_STATE().browsingState.chessboard.dismissMoveFeedback({
		// 				square: "e4",
		// 				callback: () => {},
		// 			});
		// 			await sleep(3000);
		// 			f();
		// 			// setFeedback({ result: "inaccuracy", progress: undefined });
		// 		})();
		// 	});
		// };
		// f();
		//   quick((s) => {
		//     s.repertoireState.reviewState.reviewLine(Line.fromPgn("1.e4 e5 2.f4"), s.repertoireState.getDefaultRepertoire("white")!)
		//   })
		// quick((s) => {
		// s.userState.authWithLichess({ source: "onboarding" });
		// });
		// onStockfishLoaded(() => {
		// 	quick((s) => {
		// 		UI().pushView(RepertoireOverview);
		// 		BROWSING_STATE().setActiveRepertoire(REPERTOIRE_STATE().getDefaultRepertoire("black")!.id);
		// 		UI().pushView(PreAdd);
		// 		UI().pushView(RepertoireBuilder);
		// 		s.repertoireState.browsingState.setActiveRepertoire(
		// 			s.repertoireState.getDefaultRepertoire("white")!.id,
		// 		);
		// 		UI()
		// 			.getActiveChessboard()
		// 			.playLine(
		// 				Line.fromPgn(
		// 					"1. e4 e5 2. Nf3 Nc6 3. Bc4 Nf6 4. Ng5 Bc5 5. Bxf7+ Ke7 6. Bc4 Rf8 7. O-O d6 8. Nc3 h6 9. Nh7 Nxh7 10. Nd5+ Ke8 11. Qh5+ Rf7 12. Nb6 13. Qf6 Qxf7+",
		// 				),
		// 				{ animated: false },
		// 			);
		// 		// UI().pushView(RepertoireCheckInView, {
		// 		// 	props: { loading: () => false, justCompleted: () => false },
		// 		// });
		// 		// UI().pushView(IncreaseCoverageGoal);
		// 	});
		// });
		// onStockfishLoaded(() => {
		// 	quick((s) => {
		// 		// UI().pushView(PlayView);
		// 		// s.playState.start({ line: Line.fromPgn("1. e4 e5 2. Nf3 Nc6 3. Bc4 Nf6 4. Ng5 Bc5 5. Bxf7+ Ke7 6. Bc4 Rf8 7. O-O d6 8. Nc3 h6 9. Nh7 Nxh7 10. Nd5+ Ke8 11. Qh5+ Rf7 12. Nb6"), side: "white" });
		// 		// // s.playState.gameOver = true;
		// 		// setInterval(() => {
		// 		// 	quick((s) => {
		// 		// 		// s.playState.lives--;
		// 		// 		// if (s.playState.lives < 0) {
		// 		// 		// 	s.playState.lives = 3;
		// 		// 		// }
		// 		// 	});
		// 		// }, 1000);
		// 	});
		// });
		// 	// UI().pushView(AnnotationEditSidebar, {
		// 	// 	props: {
		// 	// 		epd: UI().getActiveChessboard().getCurrentEpd(),
		// 	// 		san: "Nf6",
		// 	// 	},
		// 	// });
		// });
		// setTimeout(() => {
		// quick((s) => {
		// 	UI().pushView(AskAboutUserSource);
		// });
		// quick((s) => {
		// 	UI().pushView(RepertoireBuilder);
		// 	s.repertoireState.browsingState.startBrowsing(
		// 		s.repertoireState.getDefaultRepertoire("white")!.id,
		// 		"build",
		// 		{
		// 			lineToPlay: Line.fromPgn("1.e4 e5 2.Nf3 Nc6"),
		// 		},
		// 	);
		// });
		// 	// 	rspcClient
		// 	// 		.query([
		// 	// 			"openings.fetchPositionReports",
		// 	// 			[
		// 	// 				{
		// 	// 					epd: START_EPD,
		// 	// 					side: "white",
		// 	// 					moves: [],
		// 	// 					previousEpds: [],
		// 	// 					repertoireId: s.repertoireState.getDefaultRepertoire("white")!.id,
		// 	// 				},
		// 	// 			],
		// 	// 		])
		// 	// 		.then((data) => {
		// 	// 			UI().pushView(CourseListView, { props: { courses: data[0].courses } });
		// 	// 		});
		// });
		// quick((s) => {
		// 	UI().pushView(SelectLichessStudy);
		// });
		// }, 2000);
		// connect accounts onboarding
		// quick((s) => {
		// 	console.log("doing this quick thing!");
		// 	s.userState.pastLandingPage = true;
		// 	s.repertoireState.onboarding.isOnboarding = true;
		// 	UI().pushView(OnboardingIntro);
		// 	// UI().pushView(ConnectAccountsSetting, {
		// 	// 	props: {},
		// 	// });
		// 	// console.log("did this quick thing!");
		// });
		// quick((s) => UI().pushView(UpgradeSubscriptionView));
		// showerSuccessConfetti();
		// quick((s) => {
		// 	if (s.repertoireState.modelGamesState.dailyGame) {
		// 		s.repertoireState.modelGamesState.reviewGame(s.repertoireState.modelGamesState.dailyGame);
		// 		// times(30, () => {
		// 		// 	s.repertoireState.modelGamesState.playNextMove();
		// 		// });
		// 	}
		// });
		// quick((s) => {
		// 	UI().pushView(ModelGameHistory);
		// });
		// quick((_s) => {
		// 	// s.repertoireState.startBrowsing(
		// 	// 	s.repertoireState.getDefaultRepertoire("black")!.id,
		// 	// 	"build",
		// 	// );
		// 	// UI().pushView(RepertoireChooseEloRanges, {
		// 	// 	props: {
		// 	// 		repertoireId: s.repertoireState.getDefaultRepertoire("white")!.id,
		// 	// 	},
		// 	// });
		// 	BROWSING_STATE().setActiveRepertoire(REPERTOIRE_STATE().getDefaultRepertoire("black")!.id);
		// 	UI().pushView(RepertoireOverview);
		// });
		quick((_s) => {
			// s.repertoireState.startBrowsing(
			// 	s.repertoireState.getDefaultRepertoire("white")!.id,
			// 	"side_overview",
			// );
			// UI().pushView(RepertoireChooseEloRanges, {
			// 	props: {
			// 		repertoireId: s.repertoireState.getDefaultRepertoire("white")!.id,
			// 	},
			// });
		});
		// quick((s) => {
		// 	UI().pushView(RepertoireAudit);
		// });
		quick((s) => {
			s.repertoireState.onCorrectGameMovesCallbacks.call({
				initialDue: 69,
				numCorrect: 12,
			});
			setTimeout(() => {
				quick((s) => {
					s.repertoireState.onCorrectGameMovesCallbacks.call({
						initialDue: 10,
						numCorrect: 15,
					});
				});
			}, 6000);
		});
		// (async () => {
		// 	while (true) {
		// 		if (UI().getActiveChessboard().getPly() === 0) {
		// 			console.log("making e4 move");
		// 			UI().getActiveChessboard().makeMove("e4", { animate: true, sound: "move" });
		// 		} else {
		// 			console.log("backing one");
		// 			UI().getActiveChessboard().backOne();
		// 		}
		// 		await sleep(2000);
		// 	}
		// })();
		// });
		// quick((_s) => {
		// 	let line = Line.fromPgn(
		// 		"1. e4 c5 2. d4 cxd4 3. c3 dxc3 4. Nxc3 d5 5. exd5 Qxd5 6. Qxd5 Nc6 7. Qxc6+ bxc6",
		// 	);
		// 	// every X ms, make a move
		// 	setInterval(() => {
		// 		let move = line.shift();
		// 		if (move) {
		// 			quick((s) => {
		// 				UI().getActiveChessboard().makeMove(move, { animate: true, sound: "move" });
		// 			});
		// 		}
		// 	}, 500);
		// });
		// quick((s) => {
		//   console.log("setting past landing page");
		//   s.userState.pastLandingPage = true;
		//   // UI().replaceView(ConnectChesscom, {});
		// });
		// quick((s) => {
		//   UI().replaceView(CoverageSettings, {});
		// });
		// setTimeout(() => {
		// quick((s) => {
		// 	s.repertoireState.onboarding.isOnboarding = true;
		// 	s.repertoireState.reviewState.startReview({ filter: "all" });
		// });
		// setInterval(() => {
		// 	showerFeedbackConfetti({ x: 100, y: 100 });
		// }, 1000);
		// showerSuccessConfetti();
		// setInterval(() => {
		// 	showerSuccessConfetti();
		// }, 8000);
		// quick((s) => {
		// 	onStockfishLoaded(() => {
		// 		let pgn =
		// 			"1. d4 f5 2. c4 e6 3. Nc3 Nf6 4. Nf3 Bb4 5. e3 O-O 6. Bd3 b6 7. O-O Bxc3 8. bxc3 Bb7 9. Ba3";
		// 		let line = Line.fromPgn(pgn);
		// 		console.log("line", line);
		// 		s.repertoireState.reviewState.chessboard.playLine(line, {
		// 			animated: true,
		// 			onFinished: () => {},
		// 		});
		// 		// s.repertoireState.reviewState.startReview({});
		// 		UI().pushView(BonusMoveView);
		// 		// s.repertoireState.reviewState.chessboard.makeStockfishMove({
		// 		// 	nodes: EVAL_NODES.STANDARD,
		// 		// });
		// 		s.repertoireState.reviewState.bonusMove = true;
		// 		s.repertoireState.reviewState.reviewSide = "black";
		// 		s.repertoireState.reviewState.activeOptions = {};
		// 		// s.repertoireState.reviewState.startReview({
		// 		// 	filter: "all",
		// 		// 	repertoireId: s.repertoireState.getDefaultRepertoire("white")!.id,
		// 		// 	startLine: ["e4", "e5"],
		// 		// 	startPosition: "rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR w KQkq -",
		// 		// });
		// 		// setTimeout(() => {
		// 		// 	quick((s) => {
		// 		// 		while (
		// 		// 			s.repertoireState.reviewState.currentQuizGroup &&
		// 		// 			!Quiz.getPlans(s.repertoireState.reviewState.currentQuizGroup)
		// 		// 		) {
		// 		// 			s.repertoireState.reviewState.setupNextQuizGroup();
		// 		// 		}
		// 		// 	});
		// 		// }, 100);
		// 		// });
		// 	});
		// });
		// quick((s) => {
		// 	UI().pushView(SidebarViewTester, { props: { text: "first" } });
		// 	UI().pushView(SidebarViewTester, { props: { text: "second" } });
		// });
		// setInterval(() => {
		// 	UI().animateSidebar("right");
		// }, 3000);
		//
		//
		//
		//
		//
		// Cards stuff
		// quick((s) => {
		// 	if (isChesscards) {
		// 		s.cardsState.reviewState.startReview({
		// 			filter: "new",
		// 		});
		// 	}
		// });
		// setInterval(() => {
		// 	playSound(SOUNDS.success);
		// }, 1000);
		// quick((s) => {
		// 	UI().pushView(PreReview, {
		// 		props: {
		// 			repertoireId: REPERTOIRE_STATE().getDefaultRepertoire("white")!.id,
		// 			// startEpd: last(Line.toPositions(Line.toPgn(["e4", "e6"]))),
		// 			// startLine: ["e4", "e6"],
		// 			startEpd: last(Line.toPositions(Line.toPgn(["e4", "Nf6"]))),
		// 			startLine: ["e4", "Nf6"],
		// 		},
		// 	});
		// });
	});
	onCleanup(noop);
};
